module.exports = {
  title: '运单列表',
  route: {
    path: '/logistics',
    children: {
      path: 'logistics-orders',
    },
  },
};
